<mat-card class="example-card">
  <mat-card-header class="py-8 bg-blue-900 text-white flex rounded-t-md">
    <div class="font-bold text-3xl">{{ pageTitle }}</div>
  </mat-card-header>
  <mat-card-content class="border">
    <!------------ bare de chargement ----------------->

    <div *ngIf="exist; else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>

    <div class="flex item-center justify-start">
      <mat-form-field appearance="outline">
        <mat-label>Du</mat-label>
        <input
          matInput
          [matDatepicker]="dateDebut"
          placeholder="Du"
          [(ngModel)]="date_Debut"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="dateDebut"
        ></mat-datepicker-toggle>
        <mat-datepicker #dateDebut></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Au</mat-label>
        <input
          matInput
          [matDatepicker]="dateFin"
          placeholder="Au"
          [(ngModel)]="date_Fin"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="dateFin"
        ></mat-datepicker-toggle>
        <mat-datepicker #dateFin></mat-datepicker>
      </mat-form-field>
      <button
        [disabled]="!exist"
        (click)="getListeReservation()"
        mat-raised-button
        class="colorGreen bg-blue-600 my-8"
      >
        <mat-icon>search</mat-icon>
        Filtrer
      </button>
      <button
        [disabled]="!exist"
        mat-raised-button
        class="my-8 ml-16 bg-blue-800 text-white"
      >
        <mat-icon routerLink="{{ buttonLink }}">search</mat-icon>
        <span routerLink="{{ buttonLink }}">{{ buttonName }}</span>

        <div
          class="bg-white ml-16 rounded-sm text-blue-800 text-center inline-block h-28 cursor-pointer"
          (click)="openInNewTab(buttonLink)"
        >
          <mat-icon class="text-base">open_in_new</mat-icon>
        </div>
      </button>
    </div>
    <br />
    <app-liste
      *ngIf="columnsReservation"
      [listBtn]="listBtn"
      #listeConmponent
      [showFilter]="true"
      [showSort]="true"
      [maxHeight]="200"
      [titre]="'<h4><b>Résultats trouvées</b></h4>'"
      [dataSource]="listeReservation"
      [columns]="columnsReservation"
      (output)="output($event)"
    >
    </app-liste>
    <br />
    <!-- <div  *ngIf="listeConmponent && listeConmponent.row && columnsReservationDetail">
                    <app-liste 
                        #listeDetailConmponent
                        [showFilter]="true"
                        [showSort]="true"
                        [titre]="'<h4><b>Détail réservation</b></h4>'"
                        [dataSource]="listeReservationDetail" 
                        [columns]="columnsReservationDetail">
                    </app-liste>  
                </div>     -->
  </mat-card-content>
</mat-card>

<ng-template #frmAlertDup>
  <ng-container class="py-8 w-full rounded-2xl" fxLayout="column">
    <!-- <div fxLayout="row" fxLayoutAlign="center center" class="blue-600"><mat-icon>info_outline</mat-icon></div> -->
    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-icon class="blue-600 max-h-full">content_copy</mat-icon>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-card-title style="color: #1e88e5" class="text-4xl text-center"
        >Voulez vous Dupliquer ?
      </mat-card-title>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <h2 class="text-xl font-bold py-4 blue-600">Es-tu sûr?</h2>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <button
        mat-raised-button
        color="primary"
        [mat-dialog-close]="true"
        cdkFocusInitial
        (click)="DupliquerCircuit(Toevent)"
      >
        <mat-icon class="mr-2">check</mat-icon>Oui
      </button>
      <div fxFlex="10"></div>
      <button
        mat-raised-button
        color="warn"
        [mat-dialog-close]="true"
        cdkFocusInitial
        (click)="close()"
      >
        <mat-icon class="mr-2">close</mat-icon>Non
      </button>
    </div>
  </ng-container>
</ng-template>
